import { getDrawingRobotJourneyPage } from "./drawingRobotJourneyContent";
import { getWindPoweredCarJourneyPage } from "./windPoweredCarJourneyContent";
import { getWindPoweredCarMissionPage } from "./windPoweredCarMissionContent";
import { getConductiveDoughJourneyPage } from "./conductiveDoughJourneyContent";
import { getElectricSpiralJourneyPage } from "./electricSpiralJourneyContent";
import { getFloodRescueBridgeJourneyPage } from "./floodRescueBridgeJourneyContent";
import { getElectricSpiralMissionPage } from "./electricSpiralMissionContent";
import { getConductiveDoughMissionPage } from "./conductiveDoughMissionContent";
import { getRobotArtistMissionPage } from "./robotArtistMissionContent";
import { getRobotArtistExplorersMissionPage } from "./robotArtistExplorersMissionContent";
import { getFoodDeliveryRobotMissionPage } from "./foodDeliveryRobotMissionContent";
import { getMagnetworksMissionPage } from "./magnetworksMissionContent";
import { applyJourneyInstructionalMetadata } from "./journeyInstructionalCrosswalk";
import JOURNEY_OVERLAYS from "./i18n/overlayRegistry";
import {
  getLocalizedStepTitle,
  localizeJourneyPage,
} from "./journeyContentOverlay";

const normalizeSlug = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const getAuthoredJourneyPage = ({ journeySlug, stepId, lang }) => {
  const slug = normalizeSlug(journeySlug);
  let page = null;

  switch (slug) {
    case "mystery-of-the-robot-artist":
    case "drawing-robot":
      page = getDrawingRobotJourneyPage(stepId);
      break;

    case "robot-artist-mission":
      page = getRobotArtistMissionPage(stepId);
      break;

    case "robot-artist-explorers-mission":
      page = getRobotArtistExplorersMissionPage(stepId);
      break;

    case "food-delivery-robot-mission":
      page = getFoodDeliveryRobotMissionPage(stepId);
      break;

    case "magnetworks-mission":
      page = getMagnetworksMissionPage(stepId);
      break;

    case "wind-powered-car":
      page = getWindPoweredCarJourneyPage(stepId);
      break;

    case "wind-powered-car-mission":
      page = getWindPoweredCarMissionPage(stepId);
      break;

    case "conductive-dough":
      page = getConductiveDoughJourneyPage(stepId);
      break;

    case "conductive-dough-mission":
      page = getConductiveDoughMissionPage(stepId);
      break;

    case "electric-spiral":
      page = getElectricSpiralJourneyPage(stepId);
      break;

    case "electric-spiral-mission":
      page = getElectricSpiralMissionPage(stepId);
      break;

    case "flood-rescue-bridge":
      page = getFloodRescueBridgeJourneyPage(stepId);
      break;

    default:
      page = null;
  }

  // Translations merge over the English page BEFORE the instructional
  // metadata is applied, so authored (translated) cues win over defaults.
  const localizedPage = localizeJourneyPage({
    overlays: JOURNEY_OVERLAYS,
    journeySlug: slug,
    stepId,
    lang,
    page,
  });

  return applyJourneyInstructionalMetadata({
    journeySlug: slug,
    stepId,
    page: localizedPage,
  });
};

// Translated step-list title for the manifest step, or null (use manifest title).
export const getAuthoredJourneyStepTitle = ({ journeySlug, stepId, lang }) =>
  getLocalizedStepTitle({
    overlays: JOURNEY_OVERLAYS,
    journeySlug: normalizeSlug(journeySlug),
    stepId,
    lang,
  });

export default getAuthoredJourneyPage;
